// @flow
import NextEventsWidget from './NextEventsWidgetContainer'
export default NextEventsWidget
